import { render, staticRenderFns } from "./ChipsDialog.vue?vue&type=template&id=34af8e62&"
import script from "./ChipsDialog.vue?vue&type=script&lang=js&"
export * from "./ChipsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports